import { render, staticRenderFns } from "./ImportBasicSchool.vue?vue&type=template&id=5e928c2d&"
import script from "./ImportBasicSchool.vue?vue&type=script&lang=js&"
export * from "./ImportBasicSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports